import { useAppAuth } from '@contexts/AuthContext';
import { perfisAdmin, perfisAdminAndUnidade, perfisVisitante } from '@utils/auth/perfis';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {

  const { role, idSolicitacao } = useAppAuth();

  const location = useLocation();

  const environmentName = import.meta.env.VITE_ENV_LABEL;
  const systemVersion = import.meta.env.VITE_ENV_SYSTEM_VERSION;

  const menu = [
    {
      title: 'Solicitações/Pendências',
      links: [
        { path: '/Compliance', icon: 'fa-circle-plus', label: 'Compliance', allowedRoles: perfisAdmin },
        { path: '/CriarSolicitacao', icon: 'fa-circle-plus', label: 'Criar Solicitação', allowedRoles: perfisAdmin },
        { path: '/ConsultarSolicitacoes', icon: 'fa-magnifying-glass', label: 'Consultar Solicitações', allowedRoles: perfisAdminAndUnidade },
        { path: `/Solicitacao/${idSolicitacao}`, icon: 'fa-magnifying-glass', label: 'Visualizar Solicitação', allowedRoles: perfisVisitante },
      ],
    },
    {
      title: 'Relatórios e Indicadores',
      links: [
        { path: '/RelatorioFormularios', icon: 'fa-file-pdf', label: 'Relatório Formulários', allowedRoles: perfisAdmin },
        { path: '/AmostrasUnidade', icon: 'fa-chart-column', label: 'Amostras Por Unidade', allowedRoles: perfisAdmin },
        { path: '/AmostrasItem', icon: 'fa-chart-column', label: 'Amostras Por Item', allowedRoles: perfisAdmin },
        { path: '/RelatorioPermissoes', icon: 'fa-file-pdf', label: 'Relatório de Permissões', allowedRoles: perfisAdmin },
        { path: '/RelatorioHistorico', icon: 'fa-file-pdf', label: 'Relatório de Histórico', allowedRoles: perfisAdmin },
        { path: '/RelatorioFinalAuditoria', icon: 'fa-file-pdf', label: 'Relatório Final Auditoria', allowedRoles: perfisAdmin },
      ],
    },
    {
      title: 'Planejamento',
      links: [
        { path: '/Tarefas', icon: 'fa-list-check', label: 'Tarefas', allowedRoles: perfisAdmin },
        { path: '/CalendarioGPG', icon: 'fa-calendar', label: 'Calendário GPG', allowedRoles: perfisAdmin },
      ],
    },
    {
      title: 'Cadastros e Parâmetros',
      links: [
        { path: '/UnidadeGerencia', icon: 'fa-map', label: 'Unidade/Gerência', allowedRoles: perfisAdmin },
        { path: '/Servico', icon: 'fa-cubes', label: 'Serviço', allowedRoles: perfisAdmin },
        { path: '/Tipo', icon: 'fa-cubes', label: 'Tipo', allowedRoles: perfisAdmin },
        { path: '/Processo', icon: 'fa-cubes', label: 'Processo', allowedRoles: perfisAdmin },
        { path: '/ItensProcesso', icon: 'fa-cubes', label: 'Itens do Processo', allowedRoles: perfisAdmin },
        { path: '/TemplateEmails', icon: 'fa-solid fa-envelope', label: 'Template de E-mails', allowedRoles: perfisAdmin },
        { path: '/Formularios', icon: 'fa-gear', label: 'Formulários', allowedRoles: perfisAdmin },
        { path: '/Documentos', icon: 'fa-list-ul', label: 'Documentos', allowedRoles: perfisAdmin },
        { path: '/Usuarios', icon: 'fa-user-group', label: 'Usuários', allowedRoles: perfisAdmin },
      ],
    },
    {
      title: 'Procedimentos e manuais',
      links: [
        { path: '/ManualSistema', icon: 'fa-file-pdf', label: 'Manual do Sistema', allowedRoles: perfisAdmin },
        { path: '/ProcedimentosBasicos', icon: 'fa-file-pdf', label: 'Procedimentos Básicos', allowedRoles: perfisAdmin },
      ],
    },
  ];

  return (
    <aside className="sidebar align-items-center">
      <nav>
        <ul>
          <li>
            <Link to="/">
              <i className="fa-solid fa-house" /> <span>Home</span>
            </Link>
          </li>

          {menu.map(section => {
            const links = section.links.filter(link => {
              if (!role) return false;
              const roles = Array.isArray(link.allowedRoles)
                ? link.allowedRoles
                : [link.allowedRoles];
              return roles.includes(role);
            });

            if (!links.length) return null;

            return (
              <React.Fragment key={`sec-${section.title}`}>
                <li><h3>{section.title}</h3></li>
                {links.map(link => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className={location.pathname === link.path ? 'active' : ''}
                      title={link.label}
                    >
                      <i className={`fa-solid ${link.icon}`} />{' '}
                      <span>{link.label}</span>
                    </Link>
                  </li>
                ))}
              </React.Fragment>
            );
          })}

          {/* Rodapé simples sem CSS */}
          <li className='mt-5'>
            <p style={{ textAlign: 'center' }}>
              <small>{environmentName}</small> <br />
              <small> <strong>{systemVersion}</strong></small>
            </p>
          </li>
        </ul>
      </nav>
    </aside>
  );

};

export default Sidebar;
